// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"38960cab8fd0aea101ec","883":"0f2c7a25800629e1e84b"}[chunkId] + ".js";
};